<script setup>
import { computed } from "vue"
import { useRoute, useRouter } from "vue-router"
import { productData, categoryTitles } from "@/data/products"

const route = useRoute()
const router = useRouter()

const slug = computed(() => route.params.slug)

const categoryName = computed(() =>
  categoryTitles[slug.value] || "Категория"
)

const products = computed(() =>
  productData[slug.value] || []
)
</script>

<template>
  <div class="category">

    <header class="header">
      <button @click="router.back()">← Назад</button>
      <h1>{{ categoryName }}</h1>
    </header>

    <div class="grid">
      <div v-for="item in products" :key="item.uid || item.id" class="card">

        <span v-if="item.diameter" class="badge">
          {{ item.diameter }}
        </span>

        <img
          v-if="item.image"
          :src="item.image"
          :alt="item.name"
          loading="lazy"
        />

        <h3>{{ item.name }}</h3>

        <p v-if="item.description" class="desc">
          {{ item.description }}
        </p>

        <!-- PRICE -->
        <p class="price" v-if="typeof item.price === 'string'" v-html="item.price"></p>
        <p class="price" v-else>
          {{ item.price?.toLocaleString() }} сом
        </p>

      </div>
    </div>

  </div>
</template>


<style scoped>
.category {
  background: #111;
  min-height: 100vh;
  padding: 6rem 20px 40px;
  color: #fff;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #0f0f0f;
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.header button {
  position: absolute;
  left: 20px;
  background: #1a1a1a;
  border: 1px solid #333;
  padding: 8px 14px;
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
}

.grid {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
}

.card {
      overflow: hidden;
  background: #1a1a1a;
  border-radius: 12px;
  padding: 15px;
  text-align: center;
  display: flex;
  flex-direction: column;
  position: relative;
  transition: .2s;
}

.card:hover {
  transform: translateY(-6px);
}

.card img {
  height: 260px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 1.2rem;
    object-fit: cover;
  object-position: center; 
}

.badge {
  position: absolute;
    top: 15px;
    right: 15px;
  background: #222;
  padding: 12px 16px;
  border-radius: 6px;
  font-size: 12px;
}

.desc {
  font-size: 14px;
  opacity: .7;
  margin: 10px 0;
}

.price {
  margin-top: 1rem;
  color: #2ecc71;
  font-weight: bold;
  font-size: 16px;
}
</style>
